import { Component, effect, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { StoreService } from '../../services/store.service';
import { Contract } from '../../../features/contracts/select-contract/contracts.model';
import { ContractClientService } from '../../services/contract-client.service';
import { take } from 'rxjs';
import { TranslocoService, TranslocoModule } from '@jsverse/transloco';
import { Language } from '../../models/language.model';
import { Router } from '@angular/router';
import { SecurityService } from '../../services/security.service';
import { FilterEventService } from "../../services/filter-event.service";
import { LoginClientService } from '../../services/login-client.service';

@Component({
  selector: 'app-contextbar',
  standalone: true,
  imports: [FormsModule, DropdownModule, TranslocoModule],
  templateUrl: './contextbar.component.html',
  styleUrl: './contextbar.component.css',
})
export class ContextbarComponent implements OnInit {
  languages: Language[] = [];

  contracts: Contract[] = [];

  selectedContract?: Contract;

  selectedLanguage?: Language;

  username?: string;

  private reloadPage(): void {
    this.loginClientService.refreshToken().subscribe(() => {
      window.location.reload(); 
   });
  }

  constructor(
    private storeService: StoreService,
    private contractClientService: ContractClientService,
    private translocoService: TranslocoService,
    private loginClientService: LoginClientService,
    private router: Router,
    private securityService: SecurityService,
    private filterEventService: FilterEventService,
  ) {
    effect(() => {
      this.selectedContract = this.storeService.selectedContract();
    });
  }

  ngOnInit(): void {
    this.languages = [
      { name: 'Français', code: 'fr_FR' },
      { name: 'Anglais', code: 'en_GB' },
      { name: 'Espagnol', code: 'es_ES' },
    ];

    this.selectedContract = this.storeService.selectedContract();
    this.selectedLanguage = this.storeService.selectedLanguage();
    this.contracts = this.storeService.contracts;
  }

  handleSelectedContractChangedEvent(selectedContract: Contract) {
    if (this.storeService.selectedContract().id !== selectedContract.id) {
      this.filterEventService.sendFilterEvent('reset');

      const normalizeBase = (code?: string) => (code || '').replace('-', '_').split('_')[0].toLowerCase();
      const currentLangCode = this.storeService.selectedLanguage()?.code;
      const contractLangCode = selectedContract.langue;
      const needsLangReload = !!currentLangCode && !!contractLangCode && normalizeBase(currentLangCode) !== normalizeBase(contractLangCode);

      this.contractClientService
        .selectContract(selectedContract.id)
        .pipe(take(1))
        .subscribe((authorities) => {
          this.storeService.selectContract(this.contracts, selectedContract, authorities);

          if (needsLangReload) {
            const newLangCode = this.storeService.selectedLanguage()?.code || contractLangCode!;
            this.contractClientService
              .changeContratLanguage(newLangCode)
              .pipe(take(1))
              .subscribe(() => {
                const lang = newLangCode.split('_')[0];
                this.translocoService.setActiveLang(lang);
                this.reloadPage();
              });
          } else {
            // TODO : Probablement à retirer quand la double connexion sera résolue
            this.reloadPage();
            if (!this.securityService.isAuthorized(this.router.url)) {
              this.router.navigateByUrl('/home');
            }
          }
        });
    }
  }

  handleSelectedLanguageChangedEvent(selectedLanguage: Language) {
    if (this.storeService.selectedLanguage().code !== selectedLanguage.code) {
      this.contractClientService
        .changeContratLanguage(selectedLanguage.code)
        .pipe(take(1))
        .subscribe(() => {
          this.storeService.selectLanguage(selectedLanguage);
          const lang = selectedLanguage.code.split('_')[0];
          this.translocoService.setActiveLang(lang);
          this.reloadPage();
        });
    }
  }
}
